<script setup>
import { ref } from 'vue'

// Eventos para o pai ligar nas funções já existentes
const emit = defineEmits(['import-json', 'export-json', 'generate-pdf', 'center-all', 'clear-all'])

const fileEl = ref(null)

function onClickImport() {
  fileEl.value?.click()
}
function onPicked(e) {
  emit('import-json', e)
  // limpa o input para permitir reimportar o mesmo arquivo na sequência
  if (fileEl.value) fileEl.value.value = ''
}
function onExport() {
  emit('export-json')
}
function onGeneratePdf() {
  emit('generate-pdf')
}
function onCenterAll() {
  emit('center-all')
}
function onClearAll() {
  emit('clear-all')
}
</script>

<template>
  <div class="section">
    <label class="label">Importar / Exportar</label>
    <div class="row">
      <button class="btn" @click="onClickImport">Importar JSON</button>
      <input ref="fileEl" type="file" accept=".json,application/json" class="d-none" @change="onPicked" />
      <button class="btn" @click="onExport">Exportar JSON</button>
    </div>
    <div class="hint">Use o JSON para salvar e compartilhar o layout da pista.</div>
  </div>

  <div class="section">
    <label class="label">Relatório</label>
    <div class="row">
      <button class="btn" @click="onGeneratePdf">Gerar PDF</button>
    </div>
    <div class="hint">Gera o mapa técnico e a tabela de obstáculos.</div>
  </div>

  <div class="section">
    <label class="label">Ferramentas</label>
    <div class="row">
      <button class="btn" @click="onCenterAll">Centralizar todos</button>
      <button class="btn" @click="onClearAll">Limpar tudo</button>
    </div>
  </div>
</template>

<style scoped>
.label { margin: 0 0 6px; font-size: 13px; color: #9eb3ff; }
</style>
